/**
 PW Simple Input
 Thin wrapper/passthrough for TextInput, that adds UI icon buttons for saving/canceling
 */
import T from 'prop-types'
import _ from 'lodash'
import React from 'react'
import TextInput from './TextInput'

export default class SimpleInput extends React.Component {
  static displayName = 'SimpleInput'

  static propTypes = {
    onSave: T.func.isRequired,
    onCancel: T.func,
    className: T.string,
    isEditing: T.bool
    // PLUS all those accepted by TextInput
  }

  static defaultProps = {
    isEditing: true
  }

  handleInputSave = value => {
    this.props.onSave(value)
  }

  handleSaveClick = () => {
    const {
      invalidMessage,
      value
    } = this._inputRef.state // FIXME this is gross. add instance getters?
    if (!invalidMessage) {
      this.handleInputSave(value)
    }
  }

  handleCancelClick = () => {
    this.props.onCancel()
  }

  _handleInputRef = el => {
    this._inputRef = el
  }

  render() {
    const { props } = this
    const {
      className,
      isEditing
    } = props

    return (
      <div
        className={`simple_input ${isEditing ? 'editing' : ''} ${className}`}
      >
        <TextInput
          {..._.omit(props, ['className', 'onSave'])}
          className="grid_input stealth cell_content"
          onSave={this.handleInputSave}
          ref={this._handleInputRef}
          saveOnBlur={false}
        />
        <span
          className="btn btn-icon icon-checkmark"
          onClick={this.handleSaveClick}
          role="button"
          aria-label="Save"
        />
        {props.onCancel &&
          <span
            className="btn btn-icon icon-blocked"
            onClick={this.handleCancelClick}
            role="button"
            aria-label="Cancel"
          />
        }
      </div>
    )
  }
}
